module.exports = __webpack_public_path__ + "static/img/share-now.b13991b0.png";